import { GetterTree } from 'vuex'
import { EventStatus, PendingConsultationItem } from '../consultories/types'
import { RootState } from '@/store/types'
import { state } from '@/store/schedule/state'
import { ScheduleState, ScheduleEvent } from '@/store/schedule/types'

export const getters: GetterTree<ScheduleState, RootState> = {
  getScheduledConsultationsEvents(): Array<ScheduleEvent> {
    const acceptedEvents = state.scheduledConsultations.filter(
      (event: PendingConsultationItem) =>
        event.scheduleEventStatus == EventStatus.ACCEPTED
    )

    return acceptedEvents.map((event: PendingConsultationItem) => {
      let events: ScheduleEvent = {} as ScheduleEvent
      events = {
        id: event.id,
        doctorId: event.doctorId,
        patientId: event.patientId,
        consultoryId: event.consultoryId,
        moduleId: event.consultoryModuleId,
        moduleName: event.consultoryModuleName,
        consultoryName: event.consultoryName,
        patientName: event.patientName,
        start: event.startDate,
        end: event.endDate,
        title: event.patientName,
        content:
          event.startDateHour +
          ':' +
          event.startDateMinute +
          ' - ' +
          event.patientName,
        icon: '',
        inObservation: event.inObservation,
        status: event.scheduleEventStatus,
        statusDescription: event.eventStatus
      }

      return events
    })
  }
}
